import CollectionWithHelpers from 'app/scripts/models/collections/internal/collection-with-helpers.coffee';
import { PendingOrganization } from 'app/scripts/models/PendingOrganization';

class PendingOrganizationList extends CollectionWithHelpers {
  static initClass() {
    this.prototype.model = PendingOrganization;
  }
}
PendingOrganizationList.initClass();

export { PendingOrganizationList };
